import React, { useEffect, useState, useRef } from "react";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import ProfileController from "controllers/profileController";
import AuthController from "controllers/authController";
import { API_ENDPOINTS, subscribeEventBus } from "utils";
import { useSelector, useDispatch } from "react-redux";
import { userDataSelector } from "store/selectors/app";
import { setUserData } from "store/reducers/app";
import { FiMenu } from "react-icons/fi";
import LeftMenu from "../leftMenu";
import Translation from "../translations";
import TranslationDropdown from "../TranslationDropdown";
import notificationsIcon from "assets/images/menuIcons/notifications2.png";
import { FaUser } from "react-icons/fa";

export default function HeaderPersonalAccount() {
  const [userData, setUserDataState] = useState(() => {
    const storedUserData = localStorage.getItem("userData");
    return storedUserData ? JSON.parse(storedUserData) : {};
  });

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuButtonRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reduxUserData = useSelector(userDataSelector);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (isEmpty(userData)) {
          const userDataResponse = await ProfileController.getMe();
          setUserDataState(userDataResponse);
          dispatch(setUserData(userDataResponse));
          localStorage.setItem("userData", JSON.stringify(userDataResponse));
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    if (AuthController.isUserLoggedIn() && !reduxUserData.id) {
      fetchUserData();
    } else if (!AuthController.isUserLoggedIn()) {
      navigate("/login", { replace: true });
    } else {
      setUserDataState(reduxUserData);
    }
  }, [userData, navigate, reduxUserData, dispatch]);

  useEffect(() => {
    subscribeEventBus(API_ENDPOINTS.USER_ME, setUserDataState);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  const profilePicture = userData?.profile_picture
    ? `${userData.profile_picture}`
    : null;

  return (
    <>
      <div className="div-header-fields">
        <div className="menu-logo-container">
          <button
            ref={menuButtonRef}
            className="menu-toggle-btn"
            onClick={(e) => {
              e.stopPropagation();
              toggleMenu();
            }}
            aria-expanded={isMenuOpen}
          >
            <FiMenu size={28} />
          </button>
        </div>

        <div className="div-language-selector">
          <TranslationDropdown />
        </div>

        <div className="div-user-info">
          <img
            src={notificationsIcon}
            alt="notifications icon"
            className="notifications-icon"
          />

          <div className="div-small-line"></div>
          {profilePicture ? (
            <img
              src={profilePicture}
              alt="Profile"
              className="user-profile-picture"
            />
          ) : (
            <div className="header-purple-circle">
              <FaUser className="user-icon-wrapper" />
            </div>
          )}

          <div>
            <p className="p-flash-id">
              {userData.id ? (
                `ID: ${userData.id}`
              ) : (
                <Translation label="_loading" />
              )}
            </p>

            <span className="user-name">
              {userData.first_name} {userData.last_name}
            </span>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <LeftMenu
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={setIsMenuOpen}
          menuButtonRef={menuButtonRef}
        />
      )}
    </>
  );
}
